import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import primaryBorder from "../assets/images/border-primary.png";
import grayBorder from "../assets/images/border-gray.png";
import { getVisibleSensorAnimation } from "../assets/js/utils";
import { useSelector } from "react-redux";

function DoubleBroomSweeper({ firstComponent, secondComponent }) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <div className="double-broom-sweeper">
          <div
            className="double-broom-sweeper__first"
            style={getVisibleSensorAnimation(
              isVisible,
              `${
                generalSettings.rtlLanguage
                  ? "width-increase-flipped"
                  : "width-increase"
              } 1s 1s backwards`
            )}
          >
            <img
              src={primaryBorder}
              alt=""
              className="double-room-sweeper__primary-border"
            />
            <div className="wrapper-component">{firstComponent}</div>
          </div>
          {secondComponent && (
            <div
              style={getVisibleSensorAnimation(
                isVisible,
                `${
                  generalSettings.rtlLanguage
                    ? "width-increase-right-side-flipped"
                    : "width-increase-right-side"
                } 1s 1s backwards`
              )}
              className="double-broom-sweeper__second"
            >
              <div className="wrapper-component">{secondComponent}</div>
              <img
                src={grayBorder}
                alt=""
                className="double-room-sweeper__gray-border"
              />
            </div>
          )}
        </div>
      )}
    </VisibilitySensor>
  );
}

export default DoubleBroomSweeper;
